import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from "./ScrollToTop";
import ScrollToHash from "./ScrollToHash";
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import  ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import OperationalsDiagnostic from './pages/OperationalsDiagnostic';

function App() {
  return (
    <div className="App">
      <div className="bg-wrapper">
        <div className="bg-gradient"></div>
        <div className="bg-glow"></div>
        <div className="bg-grid"></div>

        <span className="particle p1"></span>
        <span className="particle p2"></span>
        <span className="particle p3"></span>
        <span className="particle p4"></span>
        <span className="particle p5"></span>
      </div>
      

      <BrowserRouter>
      <ScrollToTop />
      <ScrollToHash />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/our-services" element={<ServicesPage />} />
          <Route path="/our-work" element={<ProjectsPage />} /> 
          <Route path="/contact" element={<ContactPage />} /> 
          <Route path="/operationals-diagnostic" element={<OperationalsDiagnostic />} />
        </Routes>
      </BrowserRouter>
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Navbar */}
        {/* Routes */}
        {/* Pages */}
      </div>
    </div>
    
  );
}

export default App;